import cn from 'classnames'
import { AllHTMLAttributes, ElementType, FC, memo } from 'react'

import styles from './Arrow.module.scss'

import ArrowIcon from '~icons/arrow.svg'

export type ArrowDirection = 'left' | 'top' | 'right' | 'bottom'

interface ArrowProps extends Omit<AllHTMLAttributes<HTMLElement>, 'as'> {
  as?: ElementType
  direction?: ArrowDirection
  interactive?: boolean
}

const Arrow: FC<React.PropsWithChildren<ArrowProps>> = ({
  as: Component = 'button',
  type = Component === 'button' ? 'button' : undefined,
  direction = 'bottom',
  className,
  interactive,
  ...props
}) => {
  return (
    <Component
      className={cn(styles.arrow, styles[direction], interactive && styles.interactive, className)}
      type={type}
      {...props}
    >
      <ArrowIcon />
    </Component>
  )
}

export default memo(Arrow)
